type PropertyGroups = Array<[string, Array<string | number | null>]>;

export const groupPropertyOptions = (
    prefixes: ReadonlyArray<string>,
    options: Array<string | number | null>,
): PropertyGroups => {
    const sortedPrefixes = [...prefixes].sort((a, b) => b.length - a.length); // sort them from longest to shortest length so e.g. 'Boucle Tweed' will be checked before 'Boucle' and avoid overlaps

    const propertyGroups: Record<string, Array<string | number | null>> = Object.fromEntries(
        prefixes.map(prefix => {
            return [prefix, []];
        }),
    );

    propertyGroups[''] = [];

    options.forEach(propertyOption => {
        let matchedPrefix: string | undefined;

        if (typeof propertyOption === 'string') {
            matchedPrefix = sortedPrefixes.find(type => propertyOption.startsWith(type)); // find first match
        }

        propertyGroups[matchedPrefix ?? ''].push(propertyOption);
    });

    // order option groups based on the order of the original array of prefixes
    return Object.entries(propertyGroups)
        .sort(([prefixA], [prefixB]) => {
            return prefixA === prefixB
                ? 0
                : prefixA === ''
                ? 1
                : prefixB === ''
                ? -1
                : prefixes.indexOf(prefixA) - prefixes.indexOf(prefixB);
        })
        .filter(([, propertyOptions]) => propertyOptions.length > 0);
};
